module.exports = require("@ember/destroyable");